/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `workout_session` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class WorkoutSessionMesg : Mesg {
    public constructor() : super("WorkoutSession", Profile.MesgNum.WORKOUT_SESSION)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** message_index. */
    public var messageIndex: UShort?
        get() = getFieldValue(MESSAGE_INDEX_FIELD_NUM) as? UShort
        set(value) = setFieldValue(MESSAGE_INDEX_FIELD_NUM, value)

    /** sport. */
    public var sport: Sport?
        get() = (getFieldValue(SPORT_FIELD_NUM) as? UByte)?.let { Sport.fromValue(it) }
        set(value) = setFieldValue(SPORT_FIELD_NUM, value?.value)

    /** sub_sport. */
    public var subSport: SubSport?
        get() = (getFieldValue(SUB_SPORT_FIELD_NUM) as? UByte)?.let { SubSport.fromValue(it) }
        set(value) = setFieldValue(SUB_SPORT_FIELD_NUM, value?.value)

    /** num_valid_steps. */
    public var numValidSteps: UShort?
        get() = getFieldValue(NUM_VALID_STEPS_FIELD_NUM) as? UShort
        set(value) = setFieldValue(NUM_VALID_STEPS_FIELD_NUM, value)

    /** first_step_index. */
    public var firstStepIndex: UShort?
        get() = getFieldValue(FIRST_STEP_INDEX_FIELD_NUM) as? UShort
        set(value) = setFieldValue(FIRST_STEP_INDEX_FIELD_NUM, value)

    /** pool_length, in m. */
    public var poolLength: Double?
        get() = getFieldValue(POOL_LENGTH_FIELD_NUM) as? Double
        set(value) = setFieldValue(POOL_LENGTH_FIELD_NUM, value)

    /** pool_length_unit. */
    public var poolLengthUnit: DisplayMeasure?
        get() = (getFieldValue(POOL_LENGTH_UNIT_FIELD_NUM) as? UByte)?.let { DisplayMeasure.fromValue(it) }
        set(value) = setFieldValue(POOL_LENGTH_UNIT_FIELD_NUM, value?.value)

    public companion object {
        public const val MESSAGE_INDEX_FIELD_NUM: UByte = 254u
        public const val SPORT_FIELD_NUM: UByte = 0u
        public const val SUB_SPORT_FIELD_NUM: UByte = 1u
        public const val NUM_VALID_STEPS_FIELD_NUM: UByte = 2u
        public const val FIRST_STEP_INDEX_FIELD_NUM: UByte = 3u
        public const val POOL_LENGTH_FIELD_NUM: UByte = 4u
        public const val POOL_LENGTH_UNIT_FIELD_NUM: UByte = 5u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[254] = Field("MessageIndex", 254u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[0] = Field("Sport", 0u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[1] = Field("SubSport", 1u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[2] = Field("NumValidSteps", 2u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[3] = Field("FirstStepIndex", 3u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[4] = Field("PoolLength", 4u, BaseType.UINT16, 100.0, 0.0, "m", false)
            fields[5] = Field("PoolLengthUnit", 5u, BaseType.ENUM, 1.0, 0.0, "", false)
            return fields
        }
    }
}
